import {Component, OnDestroy, OnInit} from '@angular/core';
import {ROUTES} from './side-nav-routes.config';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';
import {SideNavInterface} from '@shared/interfaces/types/side-nav.type';
import {RoutingService} from '@app/service/routing/routing.service';
import {AuthState} from '@shared/state/auth/auth.state';
import {Select} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-sidenav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit, OnDestroy {
  @Select(AuthState.getIsAnonymous) isAnon$: Observable<boolean>;
  @Select(AuthState.getUserID) isAuth$: Observable<any>;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  public menuItems: SideNavInterface[];
  isExpand: boolean;

  isShowSubMenu = {};

  constructor(private themeService: ThemeConstantService, private routingService: RoutingService) {
  }

  ngOnInit(): void {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.themeService.isExpandChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isExpand => {
        this.isExpand = isExpand;
      });
  }

  toggleSubMenu(path) {
    this.isShowSubMenu[path] = path in this.isShowSubMenu ? !this.isShowSubMenu[path] : true;
  }

  closeMobileMenu(): void {
    if (window.innerWidth < 992) {
      this.isExpand = !this.isExpand;
      this.themeService.toggleExpand(this.isExpand);
    }
  }

  createAccount() {
    this.routingService.navigateRegister({redirectTo: this.routingService.getCurrentUrl()});
  }

  login() {
    this.routingService.navigateLogin();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
